import { FirebaseUserService } from './../firebase/user/firebase-user.service';
import { TokenService } from 'src/app/services/token/token.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { ACCOUNT } from '../../constants/routes';
import { URL } from '../../constants/urls.constants';
import { FirebaseUsersModel } from 'src/app/models/firebase-interfaces/firebase.users.interface';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})

export class StorageService {
  adminDetail: any;
  usersLocation: any;
  notificationCount: number = 0;

  constructor(private _router: Router,
    private $token: TokenService,
    private $firebaseUserService: FirebaseUserService,
    private $http: HttpService) { }

  get token() {
    return localStorage.getItem("session_tok");
  }

  get adminId() {
    return localStorage.getItem("_uid");
  }

  logOut() {
    localStorage.clear();
    this.adminDetail = null;
    this._router.navigate([ACCOUNT]);
  }




  async updateFCMDeviceToken(payload: any) {
    try {
      await this.$http.put(URL.updateDeviceToken, payload).toPromise();
      return
    } catch (err) {
    }
  }

  public handleUsersGeolocation(): any {
    let locationData: any = {};
    (<any>navigator.permissions).query({ name: 'geolocation' })
      .then(result => {
        if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition((result) => {
            locationData = result;
          })
          // console.log('accepted', result)
          // this.$snackBarService.open('Location permission granted', 3000, 'Successfull')
        } else if (result.state === 'denied') {
          // this.$snackBarService.open('Location is required for better user experience', 6000, 'Allow location!').subscribe(() => {
          //   navigator.geolocation.getCurrentPosition((result) => {
          //     locationData = result;
          //   })
          //   // console.log('forcefull location', result);
          // })
          // console.log(result, "denied")
        } else if (result.state === 'prompt') {
          navigator.geolocation.getCurrentPosition((result) => {
            locationData = result;
            // console.log(result, "already accepted")
            // this.$snackBarService.open('Location permission granted', 3000, 'Successfull');
          }
            , (err) => {

            }
          )
        }
        result.onChange = () => {
          if (result.state === 'denied') {
            // this.$snackBarService.open('Location is required for better user experience', 6000, 'Allow location!').subscribe(() => {
            //   navigator.geolocation.getCurrentPosition((result) => {
            //     locationData = result;
            //   })
            // })
          }
        }
        return locationData;
      })

  }


  loginSuccessfully(response: any) {
    localStorage.setItem("session_tok", response.data.accessToken);
    if (response && response.data && response.data.userId) {
      localStorage.setItem("_uid", response.data.userId);
    }
    // localStorage.setItem("_uid", response.data.adminData._id);
    // this._router.navigate(['./layout/user']);
  }

  async uploadBase64Image(fileObj: any): Promise<any> {
    try {
      let fd = new FormData();
      fd.append('image', fileObj);
      const resp: any = await this.$http.post(URL.uploadChatImage, fd).toPromise();
      if (resp) {
        return resp.data;
      }
    } catch (err) {
      return null;
    }
  }

  async resetChatCount(): Promise<boolean> {
    try {
      await this.$http.patch(URL.readChatNotification, {}, {}, false).toPromise();
      return Promise.resolve(true);
    } catch (err) {
      return Promise.reject(false);
    }
  }

  deviceDetail(info?: number) {
    /*---1=device_token, 2=deviceId, 3=platform---*/
    switch (info) {
      case 1:
        return "123";
      case 2:
        // Simplified deviceId for development
        return 'web-browser-123';
      case 3:
        return "3";
      case 4:
        return this.getTimeZone();

      case 5:
        return window.btoa('Random Device Token')
      case 6:
        // Simplified deviceId for development
        return 'web-browser-123';
    }
  }

  /**
  * @description
  * utility function to create a new firebase user
  */
  createFirebaseUser(user) {
    const subscription = new Subscription()
    const freshFirebaseUser: FirebaseUsersModel = {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      userId: user.userId,
      isActive: true,
      isUserBlocked: false,
      profilePicture: user.profilePicture,
      lastSeen: Date.now(),
      deviceType: 'web',
      deviceToken: this.deviceDetail(2)
    }
    subscription.add(
      this.$firebaseUserService.getUserFirebaseProfile(user.userId)
        .subscribe(data => {

          if (data) {
            this.$firebaseUserService.updateFirebaseUser(freshFirebaseUser.userId, freshFirebaseUser);
            removeSubscription()
          } else {
            this.$firebaseUserService.createFirebaseUser(freshFirebaseUser);
            // removeSubscription()
          }
        })
    )
    function removeSubscription() {
      subscription.unsubscribe();

    }
    // this.$firebaseUserService.createFirebaseUser(freshFirebaseUser)
  }



  setRememberme(value) {
    const payload: any = window.btoa(value);
    localStorage.setItem(environment.tokenRememberKey, JSON.stringify(payload));
  }

  getSavedUser() {
    try {
      let data: any = this.$token.getSavedUser();
      // console.log(this._token.getSavedUser())
      data = JSON.parse(window.atob(data));
      data.password = window.atob(data.password);
      if (data.email) {
        data.email = window.atob(data.email);
      }
      return data;
    } catch (err) {
      return null;
    }
  }

  checkRememberMe(body: any) {
    if (body.remember) {
      let data: any = { email: window.btoa(body.email), password: window.btoa(body.password) };
      this.$token.rememberToken(
        window.btoa(JSON.stringify(data))
      );

    } else {
      this.$token.forgetToken();
    }
  }



  // get usersGeolocation(){
  //   return this.usersGeolocation;
  // }



  // randomDeviceId() {
  //   return (window.navigator.userAgent.replace(/\D+/g, ''));
  // }

  // randomDeviceId(length) {
  //   let result = "";
  //   let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   let charactersLength = characters.length;
  //   for (let i = 0; i < length; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }
  //   return result;
  // }

  getTimeZone() {
    let date = new Date();
    let offset = date.getTimezoneOffset() * -1;
    return offset * 60 * 1000;
  }

  eraseCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  setCookie(name?, value?, days?) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    window.document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  setLocalStorage(key: string, data: any) {
    localStorage.setItem(key, data);
  }
  getDataFromLocalStorage(key: any) {
    return localStorage.getItem(key);
  }
  removeItemFromLocalStorage(item: any) {
    localStorage.removeItem(item);
  }


}
